import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2ProviderRulesBuild: build.query<
      GetV2ProviderRulesBuildApiResponse,
      GetV2ProviderRulesBuildApiArg
    >({
      query: () => ({ url: `/v2/provider/rules/build` }),
    }),
    postV2ProviderRulesBuild: build.mutation<
      PostV2ProviderRulesBuildApiResponse,
      PostV2ProviderRulesBuildApiArg
    >({
      query: () => ({ url: `/v2/provider/rules/build`, method: "POST" }),
    }),
    postV2ProviderRulesBuildFromDocument: build.mutation<
      PostV2ProviderRulesBuildFromDocumentApiResponse,
      PostV2ProviderRulesBuildFromDocumentApiArg
    >({
      query: () => ({
        url: `/v2/provider/rules/build/from-document`,
        method: "POST",
      }),
    }),
    postV2ProviderRulesBuildFromPrompt: build.mutation<
      PostV2ProviderRulesBuildFromPromptApiResponse,
      PostV2ProviderRulesBuildFromPromptApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/rules/build/from-prompt`,
        method: "POST",
        body: queryArg.fromPromptRequest,
      }),
    }),
    postV2ProviderRulesBuildFromRuleByRuleId: build.mutation<
      PostV2ProviderRulesBuildFromRuleByRuleIdApiResponse,
      PostV2ProviderRulesBuildFromRuleByRuleIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/rules/build/from-rule/${queryArg.ruleId}`,
        method: "POST",
      }),
    }),
    postV2ProviderRulesBuildByTaskIdDrafts: build.mutation<
      PostV2ProviderRulesBuildByTaskIdDraftsApiResponse,
      PostV2ProviderRulesBuildByTaskIdDraftsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/rules/build/${queryArg.taskId}/drafts`,
        method: "POST",
        body: queryArg.addDraftRequest,
      }),
    }),
    deleteV2ProviderRulesBuildByTaskIdDraftsAndDraftId: build.mutation<
      DeleteV2ProviderRulesBuildByTaskIdDraftsAndDraftIdApiResponse,
      DeleteV2ProviderRulesBuildByTaskIdDraftsAndDraftIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/rules/build/${queryArg.taskId}/drafts/${queryArg.draftId}`,
        method: "DELETE",
      }),
    }),
    patchV2ProviderRulesBuildByTaskIdDraftsAndDraftId: build.mutation<
      PatchV2ProviderRulesBuildByTaskIdDraftsAndDraftIdApiResponse,
      PatchV2ProviderRulesBuildByTaskIdDraftsAndDraftIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/rules/build/${queryArg.taskId}/drafts/${queryArg.draftId}`,
        method: "PATCH",
        body: queryArg.updateDraftRequest,
      }),
    }),
    postV2ProviderRulesBuildByTaskIdDraftsAndDraftIdMarkReady: build.mutation<
      PostV2ProviderRulesBuildByTaskIdDraftsAndDraftIdMarkReadyApiResponse,
      PostV2ProviderRulesBuildByTaskIdDraftsAndDraftIdMarkReadyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/rules/build/${queryArg.taskId}/drafts/${queryArg.draftId}/mark-ready`,
        method: "POST",
      }),
    }),
    postV2ProviderRulesBuildByTaskIdDraftsAndDraftIdMarkRejected:
      build.mutation<
        PostV2ProviderRulesBuildByTaskIdDraftsAndDraftIdMarkRejectedApiResponse,
        PostV2ProviderRulesBuildByTaskIdDraftsAndDraftIdMarkRejectedApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/rules/build/${queryArg.taskId}/drafts/${queryArg.draftId}/mark-rejected`,
          method: "POST",
        }),
      }),
    postV2ProviderRulesBuildByTaskIdDraftsAndDraftIdSave: build.mutation<
      PostV2ProviderRulesBuildByTaskIdDraftsAndDraftIdSaveApiResponse,
      PostV2ProviderRulesBuildByTaskIdDraftsAndDraftIdSaveApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/rules/build/${queryArg.taskId}/drafts/${queryArg.draftId}/save`,
        method: "POST",
      }),
    }),
    postV2ProviderRulesBuildByTaskIdSave: build.mutation<
      PostV2ProviderRulesBuildByTaskIdSaveApiResponse,
      PostV2ProviderRulesBuildByTaskIdSaveApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/rules/build/${queryArg.taskId}/save`,
        method: "POST",
        body: queryArg.saveDraftsRequest,
      }),
    }),
    getV2ProviderRulesBuildByTaskIdStatus: build.query<
      GetV2ProviderRulesBuildByTaskIdStatusApiResponse,
      GetV2ProviderRulesBuildByTaskIdStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/rules/build/${queryArg.taskId}/status`,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2ProviderRulesBuildApiResponse =
  /** status 200 OK */ TaskListResponse;
export type GetV2ProviderRulesBuildApiArg = void;
export type PostV2ProviderRulesBuildApiResponse =
  /** status 201 Created */ CreateTaskResponse;
export type PostV2ProviderRulesBuildApiArg = void;
export type PostV2ProviderRulesBuildFromDocumentApiResponse =
  /** status 201 Created */ FromDocumentResponse;
export type PostV2ProviderRulesBuildFromDocumentApiArg = void;
export type PostV2ProviderRulesBuildFromPromptApiResponse =
  /** status 201 Created */ FromPromptResponse;
export type PostV2ProviderRulesBuildFromPromptApiArg = {
  fromPromptRequest: FromPromptRequest;
};
export type PostV2ProviderRulesBuildFromRuleByRuleIdApiResponse =
  /** status 201 Created */ FromRuleResponse;
export type PostV2ProviderRulesBuildFromRuleByRuleIdApiArg = {
  ruleId: string;
};
export type PostV2ProviderRulesBuildByTaskIdDraftsApiResponse =
  /** status 201 Created */ AddDraftResponse;
export type PostV2ProviderRulesBuildByTaskIdDraftsApiArg = {
  taskId: string;
  addDraftRequest: AddDraftRequest;
};
export type DeleteV2ProviderRulesBuildByTaskIdDraftsAndDraftIdApiResponse =
  /** status 200 OK */ RuleBuildSuccessResponse;
export type DeleteV2ProviderRulesBuildByTaskIdDraftsAndDraftIdApiArg = {
  taskId: string;
  draftId: string;
};
export type PatchV2ProviderRulesBuildByTaskIdDraftsAndDraftIdApiResponse =
  /** status 200 OK */ RuleBuildSuccessResponse;
export type PatchV2ProviderRulesBuildByTaskIdDraftsAndDraftIdApiArg = {
  taskId: string;
  draftId: string;
  updateDraftRequest: UpdateDraftRequest;
};
export type PostV2ProviderRulesBuildByTaskIdDraftsAndDraftIdMarkReadyApiResponse =
  /** status 200 OK */ RuleBuildSuccessResponse;
export type PostV2ProviderRulesBuildByTaskIdDraftsAndDraftIdMarkReadyApiArg = {
  taskId: string;
  draftId: string;
};
export type PostV2ProviderRulesBuildByTaskIdDraftsAndDraftIdMarkRejectedApiResponse =
  /** status 200 OK */ RuleBuildSuccessResponse;
export type PostV2ProviderRulesBuildByTaskIdDraftsAndDraftIdMarkRejectedApiArg =
  {
    taskId: string;
    draftId: string;
  };
export type PostV2ProviderRulesBuildByTaskIdDraftsAndDraftIdSaveApiResponse =
  /** status 200 OK */ SaveSingleDraftResponse;
export type PostV2ProviderRulesBuildByTaskIdDraftsAndDraftIdSaveApiArg = {
  taskId: string;
  draftId: string;
};
export type PostV2ProviderRulesBuildByTaskIdSaveApiResponse =
  /** status 200 OK */ SaveDraftsResponse;
export type PostV2ProviderRulesBuildByTaskIdSaveApiArg = {
  taskId: string;
  saveDraftsRequest: SaveDraftsRequest;
};
export type GetV2ProviderRulesBuildByTaskIdStatusApiResponse =
  /** status 200 OK */ TaskResponse2;
export type GetV2ProviderRulesBuildByTaskIdStatusApiArg = {
  taskId: string;
};
export type DraftRuleSourceResponse = {
  document_id?: string | null;
  document_name?: string | null;
  extraction_index?: number | null;
  generation_prompt?: string | null;
  source_rule_id?: string | null;
  type: "document" | "prompt" | "existing" | "manual";
};
export type DraftRuleResponse = {
  /** Rule body in Markdown */
  body_md?: string | null;
  /** Applicable CPT codes */
  cpt_codes?: string[] | null;
  /** Creation timestamp */
  created_at: string;
  /** Draft ID */
  id: string;
  /** Applicable payers */
  payers?: string[] | null;
  /** Applicable provider types */
  provider_types?: string[] | null;
  /** ID of saved rule if saved */
  saved_rule_id?: string | null;
  /** Compact selector text */
  selector_text?: string | null;
  /** Origin of the draft */
  source: DraftRuleSourceResponse;
  /** Draft status */
  status: string;
  /** Rule title */
  title?: string | null;
  /** Last update timestamp */
  updated_at: string;
};
export type TaskResponse = {
  /** Creation timestamp */
  created_at?: string | null;
  /** Number of drafts */
  draft_count?: number;
  /** Draft rules in this task */
  draft_rules?: DraftRuleResponse[];
  /** Currently focused draft */
  focused_rule_id?: string | null;
  /** Task ID */
  id: string;
  /** Organization ID */
  organization_id: string;
  /** Number of saved rules */
  saved_count?: number;
  /** Task status */
  status: string;
  /** Last update timestamp */
  updated_at?: string | null;
  /** Owner user ID */
  user_id: string;
};
export type TaskListResponse = {
  /** List of tasks */
  tasks: TaskResponse[];
  /** Total count */
  total: number;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type CreateTaskResponse = {
  /** Task status */
  status: string;
  /** Created task ID */
  task_id: string;
};
export type FromDocumentResponse = {
  /** Uploaded document ID (if available) */
  document_id?: string | null;
  /** Task status (generating while processing) */
  status?: string;
  /** Created task ID */
  task_id: string;
};
export type FromPromptResponse = {
  /** Task status (generating while processing) */
  status?: string;
  /** Created task ID */
  task_id: string;
};
export type FromPromptRequest = {
  /** Natural language description of the rule to generate */
  prompt: string;
};
export type FromRuleResponse = {
  /** ID of the source rule being loaded */
  source_rule_id: string;
  /** Task status (generating while processing) */
  status?: string;
  /** Created task ID */
  task_id: string;
};
export type AddDraftResponse = {
  /** Created draft ID */
  draft_id: string;
  /** Draft status */
  status: string;
};
export type AddDraftRequest = {
  /** Rule body in Markdown */
  body_md?: string | null;
  /** Applicable CPT codes */
  cpt_codes?: string[] | null;
  /** Applicable payers */
  payers?: string[] | null;
  /** Applicable provider types */
  provider_types?: string[] | null;
  /** Compact selector text */
  selector_text?: string | null;
  /** Rule title */
  title?: string | null;
};
export type RuleBuildSuccessResponse = {
  /** Optional message */
  message?: string | null;
  /** Operation success */
  success?: boolean;
};
export type UpdateDraftRequest = {
  /** Updated body */
  body_md?: string | null;
  /** Updated CPT codes */
  cpt_codes?: string[] | null;
  /** Updated payers */
  payers?: string[] | null;
  /** Updated provider types */
  provider_types?: string[] | null;
  /** Updated selector text */
  selector_text?: string | null;
  /** Updated title */
  title?: string | null;
};
export type SaveSingleDraftResponse = {
  /** Whether the draft was already saved */
  already_saved?: boolean;
  /** ID of the draft that was saved */
  draft_id: string;
  /** Whether this updated an existing rule */
  is_update?: boolean;
  /** ID of the saved compliance rule */
  rule_id?: string | null;
};
export type SaveDraftsResponse = {
  /** IDs of newly created rules */
  created_rule_ids: string[];
  /** Number of rules saved */
  saved_count: number;
  /** IDs of updated rules */
  updated_rule_ids: string[];
};
export type SaveDraftsRequest = {
  /** List of draft IDs to save */
  draft_ids: string[];
};
export type DraftRuleSourceResponse2 = {
  document_id?: string | null;
  document_name?: string | null;
  extraction_index?: number | null;
  generation_prompt?: string | null;
  source_rule_id?: string | null;
  type: "document" | "prompt" | "existing" | "manual";
};
export type DraftRuleResponse2 = {
  /** Rule body in Markdown */
  body_md?: string | null;
  /** Applicable CPT codes */
  cpt_codes?: string[] | null;
  /** Creation timestamp */
  created_at: string;
  /** Draft ID */
  id: string;
  /** Applicable payers */
  payers?: string[] | null;
  /** Applicable provider types */
  provider_types?: string[] | null;
  /** ID of saved rule if saved */
  saved_rule_id?: string | null;
  /** Compact selector text */
  selector_text?: string | null;
  /** Origin of the draft */
  source: DraftRuleSourceResponse2;
  /** Draft status */
  status: string;
  /** Rule title */
  title?: string | null;
  /** Last update timestamp */
  updated_at: string;
};
export type TaskResponse2 = {
  /** Creation timestamp */
  created_at?: string | null;
  /** Number of drafts */
  draft_count?: number;
  /** Draft rules in this task */
  draft_rules?: DraftRuleResponse2[];
  /** Currently focused draft */
  focused_rule_id?: string | null;
  /** Task ID */
  id: string;
  /** Organization ID */
  organization_id: string;
  /** Number of saved rules */
  saved_count?: number;
  /** Task status */
  status: string;
  /** Last update timestamp */
  updated_at?: string | null;
  /** Owner user ID */
  user_id: string;
};
